import React from "react"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import Navigation from "./components/Navigation"
import Footer from "./components/Footer"
import HomePage from "./pages/HomePage"
import SolarPage from "./pages/SolarPage"
import PortablePage from "./pages/PortablePage"
import GuidesPage from "./pages/GuidesPage"
import HondaPage from "./pages/HondaPage"
import OnanPage from "./pages/OnanPage"
import GeneracPage from "./pages/GeneracPage"
import BriggsPage from "./pages/BriggsPage"
import ContactPage from "./pages/ContactPage"

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white flex flex-col">
        <Navigation />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/solar-backup-power" element={<SolarPage />} />
            <Route path="/portable-generator" element={<PortablePage />} />
            <Route path="/guides" element={<GuidesPage />} />
            <Route path="/honda" element={<HondaPage />} />
            <Route path="/onan" element={<OnanPage />} />
            <Route path="/generac" element={<GeneracPage />} />
            <Route path="/briggs-stratton" element={<BriggsPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  )
}

export default App
